export const WEDDINGS_GIFT_STEPS = {
  DETAILS: 'DETAILS',
  PIN_VERIFY: 'PIN_VERIFY',
  SKU_SELECTION: 'SKU_SELECTION',
  CHECKOUT: 'CHECKOUT',
  SETUP_GALLERY: 'SETUP_GALLERY',
  SEND_GIFT_NOW: 'SEND_GIFT_NOW',
  SEND_GIFT_NOW_SUCCESS: 'SEND_GIFT_NOW_SUCCESS',
};
